 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import XHTML01COVER from '@/components/xhtml/01-cover'
 import XHTMLLOVE_1 from '@/components/xhtml/love_1'
 import XHTML03TITLE from '@/components/xhtml/03-title'
 import XHTML04COPYRIGHT from '@/components/xhtml/04-copyright'
 import XHTML02FRONTMATTER from '@/components/xhtml/02-frontmatter'
 import XHTML05TOC from '@/components/xhtml/05-toc'
 import XHTML06INTRODUCTION from '@/components/xhtml/06-introduction'
 import XHTML07PART01 from '@/components/xhtml/07-part01'
 import XHTML08PART01CHAPTER01 from '@/components/xhtml/08-part01chapter01'
 import XHTML09PART01CHAPTER02 from '@/components/xhtml/09-part01chapter02'
 import XHTML10PART01CHAPTER03 from '@/components/xhtml/10-part01chapter03'
 import XHTML11PART02 from '@/components/xhtml/11-part02'
 import XHTML12PART02CHAPTER01 from '@/components/xhtml/12-part02chapter01'
 import XHTML13PART02CHAPTER02 from '@/components/xhtml/13-part02chapter02'
 import XHTML14PART02CHAPTER03 from '@/components/xhtml/14-part02chapter03'
 import XHTML15PART02CHAPTER04 from '@/components/xhtml/15-part02chapter04'
 import XHTML16PART02CHAPTER05 from '@/components/xhtml/16-part02chapter05'
 import XHTML17PART02CHAPTER06 from '@/components/xhtml/17-part02chapter06'
 import XHTML18PART02CHAPTER07 from '@/components/xhtml/18-part02chapter07'
 import XHTML19PART02CHAPTER08 from '@/components/xhtml/19-part02chapter08'
 import XHTML20PART03 from '@/components/xhtml/20-part03'
 import XHTML21PART03CHAPTER01 from '@/components/xhtml/21-part03chapter01'
 import XHTML22PART03CHAPTER02 from '@/components/xhtml/22-part03chapter02'
 import XHTML23PART03CHAPTER03 from '@/components/xhtml/23-part03chapter03'
 import XHTML24PART04 from '@/components/xhtml/24-part04'
 import XHTML25PART04CHAPTER01 from '@/components/xhtml/25-part04chapter01'
 import XHTML26PART04CHAPTER02 from '@/components/xhtml/26-part04chapter02'
 import XHTML27PART04CHAPTER03 from '@/components/xhtml/27-part04chapter03'
 import XHTML28PART04CHAPTER04 from '@/components/xhtml/28-part04chapter04'
 import XHTML29PART04CHAPTER05 from '@/components/xhtml/29-part04chapter05'
 import XHTML30PART04CHAPTER06 from '@/components/xhtml/30-part04chapter06'
 import XHTML31PART05 from '@/components/xhtml/31-part05'
 import XHTML32PART05CHAPTER01 from '@/components/xhtml/32-part05chapter01'
 import XHTML33PART05CHAPTER02 from '@/components/xhtml/33-part05chapter02'
 import XHTML34PART05CHAPTER03 from '@/components/xhtml/34-part05chapter03'
 import XHTML35PART05CHAPTER04 from '@/components/xhtml/35-part05chapter04'
 import XHTMLLOVE_2 from '@/components/xhtml/love_2'
 import XHTML36RESOURCES from '@/components/xhtml/36-resources'
 import XHTML37INDEX from '@/components/xhtml/37-index'
 import XHTML38EBOOKS from '@/components/xhtml/38-ebooks'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/xhtml/05-toc",
 			"name" : "xhtml/05-toc",
 			"component" : XHTML05TOC
 		},
 		{
 			"path" : "/xhtml/06-introduction",
 			"name" : "xhtml/06-introduction",
 			"component" : XHTML06INTRODUCTION
 		},
 		{
 			"path" : "/xhtml/07-part01",
 			"name" : "xhtml/07-part01",
 			"component" : XHTML07PART01
 		},
 		{
 			"path" : "/xhtml/08-part01chapter01",
 			"name" : "xhtml/08-part01chapter01",
 			"component" : XHTML08PART01CHAPTER01
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js